/*
 * @Description: 与SDK通信接口
 * @Date: 2019-09-19 10:35:31
 * @Author: yaoshun
 * @LastEditTime: 2019-09-19 17:45:24
 */
import jsBridge from '../common/jsBridge'
import {
    _checkIfCurrentVersionHasAndroidNoRewardProblem,
    _checkIfCurrentVersionHasIOSAlwaysRewardProblem,
    _device
} from "../common/m_base/util";

function getInvokeDatas(type, params = {}) {
    console.warn('===== >>>>> 发起一次开发者回调 >>>>>', {type, params})
    const {unitId, data} = params
    return {
        fnName: 'VideoBridge/reactDeveloper',
        params: {
            type, unitId, data
        }
    }
}

/**
 * showsuccess
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperShowSucccess(params = {}) {
    const type = 1;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * showfailed (error)
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperShowFailed(params = {}) {
    const type = 2;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * playcompleted
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperPlayCompleted(params = {}) {
    const type = 3;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * endcardshowsuccess
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperEndCardShowSuccess(params = {}) {
    const type = 4;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * clicked
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperClicked(params = {}) {
    const type = 5;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

/**
 * dismissed（boolean convert）
 * @param params
 * @returns {*|Promise<any>}
 */
export function callDeveloperDismissed(params = {}) {

    // 修复 iOS 部分 SDK 版本下存在的回调奖励问题
    if (_device().isiOS && params.data && params.data.convert === 2 && _checkIfCurrentVersionHasIOSAlwaysRewardProblem(params.currentSDKVersion)) {
        params.data.convert = 0
        console.log('5.9.0-6.3.0 iOS 用户始终获得奖励问题已修复')
    }

    // 修复 Android 部分 SDK 版本下存在的回调奖励问题
    if (_device().isAndroid && _checkIfCurrentVersionHasAndroidNoRewardProblem(params.currentSDKVersion)) {
        if (params.androidPatchData) {
            params.data.convert = params.androidPatchData.convert ? 1 : 2
            console.log('12.2.0-999.0.0 "用户始终无法获得奖励问题" 已修复')
        } else {
            console.warn('12.2.0-999.0.0 符合修复条件，但由于 SDK 的 patch data 不符合预期（一般为用户提前跳过视频，没有触发 playcomplete），"用户始终无法获得奖励" 的问题修复失败', params)
        }
    }

    const type = 6;
    const invokeParams = getInvokeDatas(type, params)
    return jsBridge.callNative(invokeParams)
}

